import React, { HTMLAttributes } from 'react';
import { ExitIcon } from '../Icons';
import cn from '@/utils/cn';
import { toastVariants } from './toastVariants';
import { VariantProps } from 'class-variance-authority';

interface ToastProps extends VariantProps<typeof toastVariants>, HTMLAttributes<HTMLDivElement> {
  isOpen: boolean;
  onClose?: () => void;
}

const Toast: React.FC<ToastProps> = ({ isOpen, onClose, variant, size, className, children }) => {
  const handleOnClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <>
      {isOpen ? (
        <div id="toast-bottom-right" className={cn(toastVariants({ variant, size, className }))}>
          {children}
          {onClose ? (
            <div>
              <button
                onClick={handleOnClose}
                className="absolute top-2 right-2 p-2 flex items-center justify-center"
                type="button"
                data-dismiss-target="#toast-bottom-right"
                aria-label="Close">
                <span className="sr-only">Close</span>
                <ExitIcon variant="inherit" size="xs" />
              </button>
            </div>
          ) : null}
        </div>
      ) : null}
    </>
  );
};

export default Toast;
